const checkboxState = {
    selectedLocations: [],
    selectedNetworkInterfaces: [],
    selectedUsers: []
};
export default checkboxState;
